import common from "../../common";
import QuestionModel from "../../maths/QuestionModel";
import QuestionViewStatement from "./QuestionViewStatement";

export default class QuestionViewStatementLong extends QuestionViewStatement {
    constructor(question) {
        super(question);
    }

    createStatement(spacing = 0) {
        let height = 0;

        this._footer.image.width = 300;
        this._footer.image.height = 300;
        this._footer.x = 0;

        const operands = [];
        for (let i = 1; i < this._question.values.length; ++i) {
            let operand = "";
            if (i < this._question.values.length - 1) {
                switch (this._question.type) {
                    case QuestionModel.TYPE_ADDITION : {
                        operand = "+";
                        break;
                    }
                    case QuestionModel.TYPE_SUBTRACTION : {
                        operand = "-";
                        break;
                    }
                    case QuestionModel.TYPE_MULTIPLICATION : {
                        operand = "x";
                        break;
                    }
                    case QuestionModel.TYPE_DIVISION : {
                        operand = "÷";
                        break;
                    }
                }
            }
            operands.push(operand);
        }

        for (let i = 0, j = 0; i < this._question.values.length; ++i) {
            const value = this._question.values[i];

            if (i !== this._question.part) {
                const label = this.createLabel(value.toString(false));
                label.position.set(60, height - 20);
                label.anchor.set(1, 0);
                this._footer.statement.addChild(label);

                if (i < this._question.values.length - 1) {
                    height += label.height + spacing;
                }
            } else {
                i > 0 && (height += this._inputField.height * 0.5);

                this._inputField.position.set(0, height - 20);
                this._footer.statement.addChild(this._inputField);

                i < this._question.values.length - 1 && (height += this._inputField.height * 0.5 + spacing);
            }
            // add operand
            const label = this.createLabel(operands[j++]);
            label.position.set(-80, height);
            this._footer.statement.addChild(label);
        }

        //add in a horizontal line instead of equals
        const line = new PIXI.Sprite(PIXI.Texture.WHITE);
        line.tint = 0x0;
        line.height = 4;
        line.anchor.set(0.5, 0);
        line.width = 120;
        line.y = height * 0.5 + 16;

        this._footer.statement.addChild(line);

        this._inputField.position.set(0, height);

        this._footer.image.pivot.set(this._footer.image.width * 0.5, this._footer.image.height * 0.5);

        //center statement
        this._footer.statement.pivot.y = height * 0.5;
    }

    filterTemplate(x) {
        return true;
    }

    isCorrect() {
        return parseInt(this._inputValue.value) === parseInt(this._question.answer.value);
    }
}